import { FaEnvelope, FaMapMarker, FaPhone } from "react-icons/fa";

export const aboutpageData = [
    { src: 'assets/images/stay-connected.png', alt: 'stay-connected', title: 'Stay Connected' },
    { src: 'assets/images/get-notified.png', alt: 'get-notified', title: 'Get Notified' },
    { src: 'assets/images/stay-updated.png', alt: 'stay-updated', title: 'Stay Updated' },
    { src: 'assets/images/mini-world.png', alt: 'mini-world', title: 'Mini World' },
  ];

  export const Homesectionimage = [
    { src: "assets/images/top-mobile.png", alt: "top1",class:'mobile-slid' },
    { src: "assets/images/top2.png", alt: "top2",class:'profile-msg' },
    { src: "assets/images/top3.png", alt: "top3",class:'awesome' },
    { src: "assets/images/top4.png", alt: "top4",class:'profile-1' },
    { src: "assets/images/top5.png", alt: "top5",class:'emoji' },
    { src: "assets/images/top1.png", alt: "top1",class:'profile-2' },
  ];

// featuresData
export const featuresLeft = [
  {
    title: "Easy Installation",
    description: "Lorem Ipsum has been the industry's"
  },
  {
    title: "Multi Platform Chat App",
    description: "Lorem Ipsum has been the industry's"
  },
  {
    title: "Secure Backup & Recovery",
    description: "Many desktop publishing packages"
  },
  {
    title: "Easy File Sharing",
    description: "Lorem Ipsum has been the industry's"
  }
];

export const featuresRight = [
  {
    title: "Easy Installation",
    description: "Lorem Ipsum has been the industry's"
  },
  {
    title: "Multi Platform Chat App",
    description: "Lorem Ipsum has been the industry's"
  },
  {
    title: "Secure Backup & Recovery",
    description: "Many desktop publishing packages"
  },
  {
    title: "Easy File Sharing",
    description: "Lorem Ipsum has been the industry's"
  }
];

 

// workData
export const workSteps = [
  {
    imgSrc: "assets/images/icon/1.png",
    title: "download app",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias non nulla placeat, odio"
  },
  {
    imgSrc: "assets/images/icon/2.png",
    title: "connect people",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias non nulla placeat, odio"
  },
  {
    imgSrc: "assets/images/icon/3.png",
    title: "enjoy app",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias non nulla placeat, odio"
  }
];


// team data

export const Teamdata = [
  { name: 'mark jkcno', designation: 'designer', photo: '1.jpg', facebook: '#', google: '#', twitter: '#', instagram: '#', rss: '#' },
  { name: 'john doe', designation: 'developer', photo: '4.jpg', facebook: '#', google: '#', twitter: '#', instagram: '#', rss: '#' },
  { name: 'johanson let', designation: 'ux designer', photo: '3.jpg', facebook: '#', google: '#', twitter: '#', instagram: '#', rss: '#' },
  { name: 'Walo Boni', designation: 'app developer', photo: '2.jpg', facebook: '#', google: '#', twitter: '#', instagram: '#', rss: '#' },
  { name: 'John Shipmen', designation: 'app designer', photo: '4.jpg', facebook: '#', google: '#', twitter: '#', instagram: '#', rss: '#' },
  { name: 'Robert Tomkins', designation: 'ceo', photo: '3.jpg', facebook: '#', google: '#', twitter: '#', instagram: '#', rss: '#' },
];

//  price data
export const Pricedata = [
  { title: 'Standard', label: 'Only the basic features', price: '49', features: ['24/7 On-site Support', 'unlimited attachment', 'customize theme'], link: '#' },
  { title: 'Premium', label: 'Take it to the next level', price: '59', features: ['1 GB of space', 'unlimited attachment', 'customize theme'], link: '#' },
  { title: 'Professional', label: 'Our biggest plan', price: '69', features: ['real time sync', 'unlimited attachment', 'customize theme'], link: '#' },
  { title: 'Standard', label: 'Our biggest plan', price: '79', features: ['real time sync', 'unlimited attachment', 'customize theme'], link: '#' },
  { title: 'Standard', label: 'Our biggest plan', price: '79', features: ['real time sync', 'unlimited attachment', 'customize theme'], link: '#' },
];


// testimonial data
export const testimonialData = [
  {name: 'Mark Jecno  (Designer & Devloper)', photo:'1.png', description:'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus'},
  {name: 'Mark Jecno  (Designer & Devloper)', photo:'1.png', description:'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus'},
  {name: 'Mark Jecno  (Designer & Devloper)', photo:'1.png', description:'Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus'},
];

// FAQData 
export const FAQData = [
  {
    id: 'zero',
    question: "01 We're ready to start now",
    answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
  },
  {
    id: 'one',
    question: "02 Sedeiusmod tm inccsetetur ?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
  },
  {
    id: 'two',
    question: "03 Sedeiusmod inc aliquatraiy?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
  },
  {
    id: 'three',
    question: "04 Tempor inc aliquatraiy?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do ei temporo incididunt ut labore et dolore magna aliqua. Ut enim ad minim exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute dolor in reprehenderit in voluptate velit esse cillum dolore",
  },
];


export const contactInfo = [
  {
    id: 1,
    icon:  <FaMapMarker/>,
    title: 'Location',
    description: '123 Business Avenue, Hoston, USA'
  },
  {
    id: 2,
    icon: <FaPhone/>,
    title: 'Call Us',
    description: '+91 123-456-7890'
  },
  {
    id: 3,
    icon: <FaEnvelope/>,
    title: 'Email Us',
    description: 'support@gmail.com'
  }
];